import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services/http-data.service';

@Injectable()
export class TechTestService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/security/tech-test');
  }

  getFetchUrl(options: any = {}) {
    const { clientId } = options;
    return `${this.baseUrl}/client/${clientId}`;
  }
}
